<template>
  <div class="page-container">
    <section class="page-header center">
    <h1 class="page-title">{{ title }}</h1>
    </section>
    <section class="form-section">
        <component :is="currentForm" />
    </section>
  </div>
</template>

<script setup>
import { computed, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'

import LoginForm from '@/components/Auth/LoginForm.vue'
import RegisterForm from '@/components/Auth/RegisterForm.vue'
import ForgotPasswordForm from '@/components/Auth/ForgotPasswordForm.vue'
import ValidateAccountForm from '@/components/Auth/ValidateForm.vue'
import ResendValidateCodeForm from '@/components/Auth/ResendValidateCodeForm.vue'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

const formMap = {
  login: LoginForm,
  register: RegisterForm,
  forgot: ForgotPasswordForm,
  validate: ValidateAccountForm,
  resend: ResendValidateCodeForm
}

const titleMap = {
  login: 'Connexion',
  register: 'Inscription',
  forgot: 'Mot de passe oublié',
  validate: 'Validation du compte',
  resend: 'Renvoyer le code'
}

const currentForm = computed(() => formMap[route.name])
const title = computed(() => titleMap[route.name])

watchEffect(() => {
  if (userStore.user) {
    router.replace({ name: 'account' })
  }
})
</script>

<style scoped>
.page-container {
  max-width: 38rem;
  padding-bottom: 4rem;
}
.page-title {
  text-align: center;
}
.form-card {
  min-width: 30rem;
}
:deep(.btn-group) {
  justify-content: space-between;
  align-items: flex-end;
}

:deep(a) {
color: var(--color-text-secondary) !important;
}

@media (max-width: 768px) {
  .page-container {
    padding-bottom: 3rem;
  }
}

</style>
